import { render, staticRenderFns } from "./FontWeight.vue?vue&type=template&id=47babca9&"
import script from "./FontWeight.vue?vue&type=script&lang=ts&"
export * from "./FontWeight.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports